import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`SSR-safe ID generation`}</h2>
    <p>{`Some Primer components generate their own DOM IDs. Those IDs must be isomorphic (so that server-side rendering and client-side rendering yield the same ID, avoiding hydration issues) and unique across the DOM. We use `}<a parentName="p" {...{
        "href": "https://react-spectrum.adobe.com/react-aria/ssr.html"
      }}>{`@react-aria/ssr`}</a>{` to generate those IDs. In client-only rendering, this doesn't require any additional work. In SSR contexts, you must wrap your application with at least one `}<inlineCode parentName="p">{`SSRProvider`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`import {SSRProvider} from '@primer/react';

function App() {
  return (
    <SSRProvider>
      <MyApplication />
    </SSRProvider>
  )
}
`}</code></pre>
    <p><inlineCode parentName="p">{`SSRProvider`}</inlineCode>{` maintains the context necessary to ensure IDs are consistent. In cases where some parts of the react tree are rendered asynchronously, you should wrap an additional `}<inlineCode parentName="p">{`SSRProvider`}</inlineCode>{` around the conditionally rendered elements:`}</p>
    <pre><code parentName="pre" {...{}}>{`function MyApplication() {
  const [dataA] = useAsyncData('a');
  const [dataB] = useAsyncData('b');

  return (
    <>
      <SSRProvider>
        {dataA && <MyComponentA data={dataA} />}
      </SSRProvider>
      <SSRProvider>
        {dataB && <MyComponentB data={dataB} />}
      </SSRProvider>
    </>
  )
}
`}</code></pre>
    <p>{`This will ensure that the IDs are consistent for any sequencing of `}<inlineCode parentName="p">{`dataA`}</inlineCode>{` and `}<inlineCode parentName="p">{`dataB`}</inlineCode>{` being resolved.`}</p>
    <p>{`See also `}<a parentName="p" {...{
        "href": "https://react-spectrum.adobe.com/react-aria/ssr.html"
      }}>{`React Aria's server side rendering documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      